import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function libraryDiscountStart({ outletId }) {
  pushClevertapEvent('Library Discount Start', {
    'Current Selected Outlet': outletId,
  });
}

export function libraryDiscountChangeOutlet({ prevOutlet, currOutlet }) {
  pushClevertapEvent('Library Discount Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryDiscountCreate({ discount, allOutlet }) {
  const eventName = allOutlet
    ? 'Library Discount Create All Outlet'
    : 'Library Discount Create One Outlet';
  pushClevertapEvent(eventName, {
    Name: discount.name,
    Value: discount.amount,
    Type: discount.type,
  });
}

export function libraryDiscountUpdate({ oldDiscount, newDiscount }) {
  pushClevertapEvent('Library Discount Update One Outlet', {
    'Old Name': oldDiscount.name,
    'Old Type': oldDiscount.type ? 'percentage' : 'rupiah',
    'New Name': newDiscount.name,
    'New Type': newDiscount.type,
    Value: newDiscount.amount,
  });
}

export function libraryDiscountDelete({ discount }) {
  pushClevertapEvent('Library Discount Delete', {
    Name: discount.name,
    Type: discount.type,
    Value: discount.amount,
  });
}
